/* Mobile buy bar: mirrors the selected variant and clicks the native add-to-cart button. */
if (!customElements.get('milla-sticky-atc')) {
  customElements.define(
    'milla-sticky-atc',
    class MillaStickyAtc extends HTMLElement {
      connectedCallback() {
        this.hidden = true;
        if (this.closest('quick-add-modal') || !window.IntersectionObserver) return;

        this.sectionId = this.dataset.section;
        this.productInfo = this.closest('product-info');
        this.button = this.querySelector('.milla-sticky-atc__button');
        const submit = this.submitButton;
        if (!this.productInfo || !this.button || !submit) return;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.submitVisible = true;
        this.update = () => {
          const show = this.mobile.matches && !this.submitVisible;
          this.hidden = !show;
          document.body.classList.toggle('milla-sticky-atc-visible', show);
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.submitVisible = entry.isIntersecting;
          });
          this.update();
        });
        this.observer.observe(submit);

        this.onClick = () => {
          const nativeSubmit = this.submitButton;
          if (!nativeSubmit || nativeSubmit.hasAttribute('disabled')) {
            this.productInfo.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          nativeSubmit.click();
        };
        this.button.addEventListener('click', this.onClick);
        this.mobile.addEventListener('change', this.update);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.update);
        this.button?.removeEventListener('click', this.onClick);
        this.unsubscribe?.();
        document.body.classList.remove('milla-sticky-atc-visible');
      }

      get submitButton() {
        return this.productInfo?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
      }

      onVariantChange(event) {
        const data = event?.data;
        if (!data || data.sectionId !== this.sectionId || !data.html) return;
        const source = data.html.getElementById(`MillaStickyInfo-${this.sectionId}`);
        const destination = this.querySelector(`#MillaStickyInfo-${this.sectionId}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.syncButton();
      }

      syncButton() {
        const nativeSubmit = this.submitButton;
        const disabled = !nativeSubmit || nativeSubmit.hasAttribute('disabled');
        this.button.disabled = disabled;
        this.button.textContent = disabled
          ? (window.variantStrings && window.variantStrings.soldOut) || 'Ausverkauft'
          : 'In den Warenkorb';
      }
    }
  );
}
